import { canv } from "@/canv/global.js";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapeDirectAccessStorage extends Shape {
    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 3) / 4 - 2 * horizontalPadding;
        const allowedHeight = height - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + (width * 3) / 4 / 2 - textPart.width / 2;
        textPart.startY = y + this.getTextLineHeight(textPart) + height / 2 - textPart.height / 2;

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, width: number, height: number) {
        let r = height / 30;

        if (width < 2 * r) r = width / 2;

        canv.ctx.beginPath();
        canv.ctx.ellipse(
            x + (width * 7) / 8,
            y + height / 2,
            width / 8,
            height / 2,
            0,
            0,
            2 * Math.PI,
        );
        canv.ctx.closePath();
        canv.ctx.moveTo(x + (width * 7) / 8, y);
        canv.ctx.lineTo(x + width / 16, y);
        canv.ctx.ellipse(
            x + width / 16,
            y + height / 2,
            width / 16,
            height / 2,
            0,
            (3 / 2) * Math.PI,
            Math.PI / 2,
            true,
        );
        canv.ctx.lineTo(x + (width * 7) / 8, y + height);
        canv.ctx.moveTo(x + width, y + height / 2);
        canv.ctx.ellipse(
            x + (width * 7) / 8,
            y + height / 2,
            width / 8,
            height / 2,
            0,
            0,
            2 * Math.PI,
        );
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path fill="${fill}" d="M0 0h24v24H0z"/>
                <path stroke="${stroke}" d="M20.01 1.1C19.4.95 4.46.99 4.11 1.1-.04 2.34-.04 22.46 4.1 22.9c.3.03 15.3.18 15.9 0m0-21.81c3.83.93 4.14 20.56 0 21.81m0-21.81c-3.18 1.87-3.18 19.94 0 21.81"/>
            </svg>
        `;
    }
}
